<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-confirm-modal-list">
      <div class="flow-sequence-title">Próximo destino do paciente:</div>
    </div>
    <div class="flow-sequence-body">
      <div class="location">
        {{flowSequence[1].destinyRoomName ? 'Sala: ' :
        (flowSequence[1].destinySectorName ? 'Setor: ' : 'Serviço: ')}}
      </div>
      <div class="location-name">
        <b>{{flowSequence[1].destinyRoomName ? flowSequence[1].destinyRoomName :
          (flowSequence[1].destinySectorName ? flowSequence[1].destinySectorName :
        flowSequence[1].destinyServiceName)}}</b>
      </div>
    </div>
    @if (!readOnly && !data.isBedManagement) {
      <div class="footer-confirm-modal-list">
        <button mat-flat-button color="primary" class="btn-block" (click)="submit()">
          @if (isLoading == false) {
            <span>Encaminhar</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
        <button type="button" mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</button>
      </div>
    }
    @if (readOnly && !data.isBedManagement) {
      <div class="footer-confirm-modal-list">
        <button mat-flat-button color="primary" class="btn-block" (click)="clickConfirm()">
          @if (isLoading == false) {
            <span>Confirmar</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
        <button type="button" mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</button>
      </div>
    }
    @if (data.isBedManagement) {
      <div class="footer-confirm-modal-list">
        <button mat-flat-button color="primary" class="btn-block" (click)="submit(true)">
          @if (isLoading == false) {
            <span>Encaminhar e remover o episodio do leito</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
        <button mat-flat-button color="primary" class="btn-block" (click)="submit()">
          @if (isLoading == false) {
            <span>Encaminhar e manter o leito ocupado com aquele episodio</span>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
        <button mat-flat-button color="accent" class="btn-block"(click)="clickCancel()">Cancelar</button>
      </div>
    }
  </div>
</div>